export type SupplyAppsTableName = `${string}-apps-table`;
export type SupplyDistributionTableName = `${string}-distribution-table`;
export type SupplyManagementTableName = `${string}-management-table`;
export type SupplyMetadataTableName = `${string}supply-metadata-table`;
export type SupplyWorkflowTableName = `${string}-workflow-table`;

export type SupplyBulkActionsBucketName =
    `${string}-supply-bulk-actions-bucket`;
